import { useCopyShortcut } from './useCopyShortcut'
import { usePrintShortcut } from './usePrintShortcut'
import { useSearchShortcut } from './useSearchShortcut'

export const useCreateShortcutContext = () => {
  const search = useSearchShortcut()
  const print = usePrintShortcut()
  const copy = useCopyShortcut()

  return {
    search,
    print,
    copy,
  }
}
